module.exports = __webpack_public_path__ + "img/hp.15bff520.png";